import { useQuery } from '@tanstack/react-query';
import FenceCalculator from './components/calculator';
function Home() {
    // const { data, isLoading, error } = useQuery({
    //     queryKey: ['user'],
    //     queryFn: () => fetch(`${REACT_APP_API}/users`, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //         }
    //     }).then((res) => res.json()),
    // });

    // if (isLoading) return <div>Loading...</div>;
    // if (error) return <div>Error: {error.message}</div>;

    return (
        <FenceCalculator />
    );
}

export default Home;
